// extracted by mini-css-extract-plugin
module.exports = {"filters":"da51a739f7--filters--FCZi8","list":"da51a739f7--list--wkKvz","list__item":"da51a739f7--list__item--c5Zml"};